import { render, staticRenderFns } from "./courseGroupList.vue?vue&type=template&id=4988e5d2&scoped=true&"
import script from "./courseGroupList.vue?vue&type=script&lang=js&"
export * from "./courseGroupList.vue?vue&type=script&lang=js&"
import style0 from "./courseGroupList.vue?vue&type=style&index=0&id=4988e5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4988e5d2",
  null
  
)

export default component.exports